import { useQuery } from "@tanstack/react-query";
import { AppointmentConfigurationControllerApi } from "../../services";
import { getConfigObject } from "../../utils/utils";

type Params = {
  page?: number;
  size?: number;
  sortBy?: string;
  sortDirection?: string;
  archive?: boolean;
  enabled?: boolean;
  xTENANTID:string,
};

export const useGetAllAppointmentConfigurations = ({
  page,
  size,
  sortBy,
  sortDirection,
  archive,
  enabled = true,
  xTENANTID
}: Params) => {
  
  return useQuery({
    queryKey: [
      "appointment-configurations",
      page,
      size,
      sortBy,
      sortDirection,
      archive,
      xTENANTID,
    ],
    enabled,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new AppointmentConfigurationControllerApi(getConfigObject())
        .getAllConfigurations(
          page,
          size,
          sortBy,
          sortDirection,
          archive,
          xTENANTID
        )
        .then((res) => res?.data),
  });
};
